const saveGPTSession = (Server_type, GPT_token) => {
  localStorage.setItem(Server_type + "_GPT_token", GPT_token);
};

export default saveGPTSession;
